import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { Button, DefaultPopup, Label } from '@atlas/ui';

import useTranslate from 'common/I18n/Interpreter';

const OneClickSignUp = ({ data = {}, id }) => {
  const { onClose = () => {} } = data;
  const t = useTranslate();

  const handleContinueButtonClick = useCallback(() => {
    NotificationManager.removeNotification(id);
    onClose();
  }, [id, onClose]);

  const downloadTxt = useCallback(
    e => {
      e.preventDefault();
      const text = `${t('Id')}: ${data.clientId}\n${t('Login')}: ${data.login}\n${t('Password')}: ${
        data.password
      }`;
      const element = document.createElement('a');
      element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`);
      element.setAttribute('download', 'Credentials.txt');
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    [data],
  );

  const copy = useCallback(
    e => {
      e.preventDefault();
      const text = `${t('Id')}: ${data.clientId}\n${t('Login')}: ${data.login}\n${t('Password')}: ${
        data.password
      }`;
      const inp = document.createElement('textarea');
      document.body.appendChild(inp);
      inp.value = text;
      inp.select();
      document.execCommand('copy', false);
      document.body.removeChild(inp);
    },
    [data],
  );

  return (
    <DefaultPopup className="popup__auth" headerTitle="sign_up" onClose={handleContinueButtonClick}>
      <div className="popup__content">
        <Label className="signup-successful-modal__subtext" message="signup_report_important" />
        <Label className="signup-successful-modal__text" message="signup_report_text" />

        <div className="signup-successful-modal__inner">
          <div className="signup-successful-modal-info">
            <div className="signup-successful-modal-info__item">
              <span className="signup-successful-modal-info__key">
                <Label message="id" />
              </span>
              <span className="signup-successful-modal-info__value">{data.clientId}</span>
            </div>
            <div className="signup-successful-modal-info__item">
              <span className="signup-successful-modal-info__key">
                <Label message="login" />
              </span>
              <span className="signup-successful-modal-info__value">{data.login}</span>
            </div>
            <div className="signup-successful-modal-info__item">
              <span className="signup-successful-modal-info__key">
                <Label message="password" />
              </span>
              <span className="signup-successful-modal-info__value">{data.password}</span>
            </div>
          </div>

          <div className="signup-successful-modal__buttons">
            <Button className="btn secondary big block" label="Copy" onClick={copy} />

            <Button className="btn secondary big block" label="Download" onClick={downloadTxt} />
          </div>

          <Label
            className="signup-successful-modal__description"
            message="signup_report_description"
          />
        </div>

        <button className="btn primary big block" onClick={handleContinueButtonClick} type="button">
          <Label message="next" />
        </button>
      </div>
    </DefaultPopup>
  );
};

OneClickSignUp.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string.isRequired,
};

export default OneClickSignUp;
